// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3BAHZ","content":"styles_content__14AaC","phone":"styles_phone__2z0EJ"};